import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
import { Button, Divider, message, Form, Input } from "antd";
import ListBackBtn from "../../../BusinessDashboard/components/ListBackBtn";
import ConfirmAction from "../../../../utils/ConfirmAction";

export default function VideosSettings(props) {
  const { handleGetVideosWaitingValidation } = props;

  const { id: videosID } = useParams();
  const location = useLocation();
  const [videos, setVideos] = useState(null);
  const [metaData, setMetaData] = useState({});
  const [userWhoApproved, setUserWhoApproved] = useState();

  const user = useSelector((state) => state.user.user);

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const createMetaDataObj = (arr) => {
    let data = {};
    arr.forEach((element) => {
      const meta_key = element.meta_key;
      const meta_value = element.meta_value;
      data[meta_key] = meta_value;
    });
    setMetaData(data);
  };

  useEffect(() => {
    // Check if we have video data from navigation state
    if (location.state?.videoData) {
      setVideos(location.state.videoData);
      // If the video data has meta_data, process it
      if (location.state.videoData.meta_data) {
        createMetaDataObj(location.state.videoData.meta_data);
      }
      // If we have user_who_approved_name, set it
      if (location.state.videoData.user_who_approved_name) {
        setUserWhoApproved(location.state.videoData.user_who_approved_name);
      }
    }
  }, [videosID, location.state]);

  const onFinish = async (values, activatedValue) => {
    const data = {
      media_id: videos.id,
    };

    try {
      await axiosWithAuth().put(
        `${process.env.REACT_APP_BE_API_URL}/api/business/media/approved`,
        data
      );

      navigate(`/bizzll-management/videos-management`);

      if (handleGetVideosWaitingValidation) {
        await handleGetVideosWaitingValidation();
      }

      const config = {
        content: "Video Approved Successfully",
        style: {
          background: "none",
        },
      };
      message.success(config);
    } catch (error) {
      const config = {
        content: error.response?.data?.message || "Generic error occurred",
        style: {
          background: "none",
        },
        duration: 6,
      };
      message.error(config);
      console.log(error);
    }
  };

  const handleApprove = () => {
    form
      .validateFields()
      .then((values) => onFinish(values, 1))
      .catch((errorInfo) => console.log(errorInfo));
  };

  // const handleRequestChanges = () => {
  //   form
  //     .validateFields()
  //     .then((values) => onFinish(values, 2))
  //     .catch((errorInfo) => console.log(errorInfo));
  // };

  // const handleDeny = () => {
  //   form
  //     .validateFields()
  //     .then((values) => onFinish(values, 3))
  //     .catch((errorInfo) => console.log(errorInfo));
  // };

  return (
    <>
      <ListBackBtn
        backURL="/bizzll-management/videos-management"
        btnTxt="Back To Inactive Videos List"
      />
      {videos && (
        <>
          <h3>Videos Name: {videos.name}</h3>
          <h3>Videos URL: {videos.url}</h3>

          <Divider />

          <h3>Business Name: {videos.businessInfo?.name || "N/A"}</h3>
          <h3>
            Business Email: {videos.businessInfo?.business_email || "N/A"}
          </h3>
          <h3>
            FEI/EIN Number:{" "}
            {videos.businessInfo?.business_fei_ein_number || "N/A"}
          </h3>

          {metaData.user_who_approved && (
            <>
              <Divider />
              {userWhoApproved && <h3>Management User: {userWhoApproved}</h3>}
              <h3>Comment: {metaData.approval_comment}</h3>
            </>
          )}
        </>
      )}

      <Divider />

      <Form.Item>
        <Button
          type="primary"
          onClick={handleApprove}
          style={{
            marginRight: 15,
          }}
        >
          Approve
        </Button>
      </Form.Item>
    </>
  );
}
